import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditCatalogs from './EditCatalogs'
import ListCatalogs from './ListCatalogs'
import NewCatalogs from './NewCatalogs'

const AdminCatalogsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCatalogs /></PrivateRoute7>} />
        <Route path="edit-catalog" element={<PrivateRoute7><EditCatalogs /></PrivateRoute7>} />
        <Route path="new-catalog" element={<PrivateRoute7><NewCatalogs /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCatalogsRoutes